import React, { Component } from "react";
import { connect } from "react-redux";
import { CONFIG } from "../../../../config";
import { cekCookies } from "../../../../actions";
import __ from "lodash";
import { Alert } from "react-bootstrap";
import LoaderModal from "../../../modal/LoaderModal";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import accountManagement from "../../../../apis/accountManagement";

class ImportSoal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      resMessage: "",
      alertShow: false,
      isFetching: false,
      file: "",
      keterangan: "",
    };
  }
  async componentDidMount() {
    this.setState({ isFetching: true });
    await this.props.cekCookies();
    this.setState({ isFetching: false });
  }
  handleInput = (e) => {
    this.setState({
      keterangan: e.target.value,
    });
  };
  onFileChange = (event) => {
    this.setState({
      file: event.target.files[0],
    });
  };
  handleSubmit = async (event) => {
    this.setState({ isFetching: true });

    //console.log('file',this.state.file.size)
    event.preventDefault();
    if (this.state.file != "" && this.state.file.size < 1000000) {
      let data = new FormData();
      data.append("file", this.state.file);
      data.append("keterangan", this.state.keterangan);
      data.append("idAdmin", this.props.account.idAdmin ? this.props.account.idAdmin : null);
      data.append("idGuru", this.props.account.idGuru ? this.props.account.idGuru : null);
      const response = await accountManagement.post(CONFIG.SOAL_UPLOAD, data).catch(function (error) {
        this.setState({ error });
      });

      if (response) {
        this.setState({
          resMessage: response.data.errorSchema,
          isFetching: false,
          alertShow: true,
          file: "",
          keterangan: "",
        });
        document.getElementById("file").value = "";
      }
    } else {
      this.setState({
        resMessage: "File Dokumen harus < 1Mb ..!!",
        alertShow: true,
        isFetching: false,
      });

      //alert('Terjadi Kesalahan... File harus < 1Mb')
    }
  };
  loadAlert = () => {
    const { alertShow, resMessage } = this.state;

    if (alertShow) {
      return (
        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{resMessage.errorMessage}</strong>
        </Alert>
      );
    }
  };

  render() {
    const { error, isFetching } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    }
    return (
      <div className="wrapper">
        <LoaderModal isFetching={isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar />
          <div className="row">
            <div className="col-md-12">
              <h4>UPLOAD SOAL</h4>
            </div>
          </div>
          {this.loadAlert()}
          <div className="row">
            <div className="col-md-5">
              <div class="card">
                <div class="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label>
                        <span className="text-danger">*</span>Pilih File:{" "}
                      </label>
                      <input type="file" className="form-control" required onChange={this.onFileChange} id="file" accept=".docx" />
                    </div>
                    <div className="form-group">
                      <label>
                        <span className="text-danger">*</span>Keterangan:{" "}
                      </label>
                      <input type="text" className="form-control" value={this.state.keterangan} required onChange={this.handleInput} placeholder="ex : KUMSOL Bahasa Inggris Kelas 12 SMA..." />
                    </div>
                    <br />
                    <button type="submit" value="Submit" className="btn btn-primary">
                      <li className="fa fa-upload"> Upload</li>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div class="card">
                <div class="card-body">
                  <h5>Prosedur Upload Soal :</h5>
                  <ol>
                    <li>Download format dokumen (.docx)&nbsp;</li>
                    <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                    <li>
                      Format dokumen wajib&nbsp;
                      <span class="text-danger">
                        <strong>*</strong>
                      </span>
                      <strong>.docx</strong>
                      <span class="text-danger">
                        <strong>*</strong>
                      </span>
                    </li>
                    <li>PASTIKAN TIDAK ADA IMPORT FILE LEBIH DARI 1 KALI, KARENA AKAN MENYEBABKAN DUPLIKASI SOAL!!</li>
                    <br />
                    <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + "/FORM_IMPORT_SOAL.docx"}>
                      <li className="fa fa-download"> Download</li>
                    </a>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ImportSoal);
